/**
 * O que torna um texto do documento clicável para editar (E202.F2, GUS-145): o papel de botão, o foco
 * pelo teclado (Enter ou espaço abre), a dica e o realce discreto ao passar o mouse. O clique que
 * selecionou texto (para copiar) não abre o editor.
 */
import type { HTMLAttributes, KeyboardEvent } from 'react';

import { ptBR } from '@/i18n/pt-BR';

export const REALCE_CLICAVEL =
  'cursor-text hover:bg-[#F2F6FA] focus-visible:outline focus-visible:outline-2';

function semSelecao(): boolean {
  return (window.getSelection?.()?.toString() ?? '') === '';
}

/** E203.F2: o realce do que abre o painel do dado (tabela, linha, texto protegido). */
export const REALCE_DO_DADO =
  'cursor-pointer hover:bg-[#F2F6FA] focus-visible:outline focus-visible:outline-2';

/**
 * As propriedades do elemento clicável; sem `abrir`, nenhuma (o texto é protegido). `abrir` recebe o
 * elemento clicado (o painel do dado abre ao lado dele e devolve o foco a ele).
 */
export function clicavel(
  abrir: ((elemento: HTMLElement) => void) | null,
  dica: string = ptBR.documentoDaMesa.edicao.editar,
): HTMLAttributes<HTMLElement> {
  if (abrir === null) return {};
  return {
    role: 'button',
    tabIndex: 0,
    title: dica,
    onClick: (e) => {
      if (semSelecao()) abrir(e.currentTarget as HTMLElement);
    },
    onKeyDown: (e: KeyboardEvent) => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target === e.currentTarget) {
        e.preventDefault();
        abrir(e.currentTarget as HTMLElement);
      }
    },
  };
}

export { semSelecao };
